import { combineReducers } from "redux";

import authReducer from "./AuthReducer";
import roleAndPermissionsReducer from "./RoleAndPermissionsReducer";
import usersReducer from "./UsersReducer";
import SiteReducer from "./SiteReducer";

export default combineReducers({
  auth: authReducer,
  roleAndPermissions:roleAndPermissionsReducer,
  users:usersReducer,
  SiteReducer
});
